<template>
  <div class="base-input" :class="{ error: hasValidationError }">
    <label
      @click="() => !readonly && $refs.input.focus()"
      v-if="label && readonly"
      :class="['input__label', { readonly }]"
      >{{ label }}</label
    >
    <textarea
      autocomplete="off"
      ref="input"
      v-model="inputValue"
      @focus="$emit('focus')"
      @blur="handleBlur"
      :name="name"
      :placeholder="readonly ? '-' : placeholder"
      class="input__field"
      :readonly="readonly"
      :disabled="loading"
      :maxlength="limitMaxLength"
    />
    <slot
      v-if="hasValidationError && !serverValidationPending"
      class="validation-messages"
    />
  </div>
</template>

<script>
import Base from "./Base/Base.vue";

export default {
  name: "vtextarea",
  extends: Base,
  methods: {
    handleBlur() {
      this.$emit("blur");
      this.validate();
    },
  },
};
</script>

<style lang="scss" scoped>
textarea {
  resize: none;
  height: 127px;
  overflow: hidden auto;
  max-width: 100%;
  scrollbar-width: none;
  scrollbar-color: transparent;
  padding: 12px;
}

.input__field:not(:disabled):read-only {
  height: 300px;
}

.readonly-block {
  word-break: break-word;
  line-height: 150%;
}

::-webkit-scrollbar {
  width: 8px;
}
 
::-webkit-scrollbar-track {
  background: rgba(0, 66, 105, 0.24);
  border-radius: 4px;
  transform: matrix(0, 1, 1, 0, 0, 0);
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 66, 105, 0.24);
  border-radius: 4px;
  transform: matrix(0, 1, 1, 0, 0, 0);
}
</style>
